import React from 'react';
import { MdOutlineSupportAgent } from 'react-icons/md';
import { theme } from 'lib/style';
import { Heading, ParagraphSmall } from 'lib/components/styles/typography';
import {
  MainWrapper,
  Union,
  ContentWrapper,
  BtnWrapper,
  ImageWrapper,
} from './styles';
import proCardImgReports from './not-connected.png';
import { Button } from 'react-covideo-common';
import { useCDK } from '../../../lib/hooks/useCdk';
import { useTranslation } from 'react-i18next';

type Props = {
  position?: 'relative' | 'fixed';
  style?: React.CSSProperties | undefined;
};

export const NotFound = ({ position = 'relative', style }: Props) => {
  const { isCdkUser, homePath } = useCDK();
  const { t } = useTranslation();

  const resetErrorBoundary = () => {
    window.location.href = homePath;
  };

  return (
    <MainWrapper position={position} style={style}>
      <ContentWrapper>
        <Heading
          style={{ fontFamily: 'Work Sans' }}
          color={theme.palette.primaryDarkBlue}
        >
          {t("Oops! Something's not right...")}
        </Heading>
        <BtnWrapper>
          <Button
            onClick={resetErrorBoundary}
            text={t('Go to your library')}
            icon={<Union width={16} />}
          />
          {!isCdkUser && (
            <>
              <ParagraphSmall color='#9297a2'>or</ParagraphSmall>
              <a style={{ textDecoration: 'none' }} href='tel:+1800.306.1445'>
                <Button
                  text={t('Contact Support')}
                  icon={<MdOutlineSupportAgent size={24} />}
                  variant='secondary'
                />
              </a>
            </>
          )}
        </BtnWrapper>
      </ContentWrapper>
      <ImageWrapper>
        <img alt='not connected' src={proCardImgReports} />
      </ImageWrapper>
    </MainWrapper>
  );
};
